<template>
  <div>
    <label class="filter-title">
      <b>
        ค้นหาโครงการ
      </b>
    </label>
    <div class="filter">
      <div class="input-type">
        <el-radio-group
          v-model="
            search.type
          "
          class="
            radio-group
          ">
          <el-radio
            v-for="
              (item, i) in [
                { name: 'ทั้งหมด', value: 'ALL' }, ...category
              ]
            "
            :key="i"
            :label="
              item.value
            "
            type="sc-asset">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="input-text">
        <input
          v-model="
            search.text
          "
          :placeholder="
            'ชื่อ, รหัส, หรือ ที่อยู่โครงการ'
          "
          type="text"
          class="
            el-input__inner
          "
          @keyup.enter="
            $emit('search')
          "
        />
        <el-button
          type="sc-asset"
          icon="
            el-icon-search
          "
          @click="
            () => $emit('search')
          ">
          ค้นหา
        </el-button>
      </div>
    </div>
    
  </div>
</template>

<script lang="js">

// Services
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

export default {
  props: {
    filter: {
      type: Object,
      default: () => ({
        text: '',
        type: 'ALL'
      })
    },
  },
  data() {
    return {
      search: {
        text: '',
        type: 'ALL'
      },
    }
  },
  computed: {
    category() {
      return Common.category
    }
  },
  watch: {
    search: {
      handler() {
        this.$emit(
          'change', this.search
        )
      },
      deep: true
    }
  },
  mounted () {
    if (this.filter) {
      this.search = this.filter
    }
  },
}

</script>

<style scoped>

.filter {
  display         : flex;
  flex-direction  : column;
  gap             : var(--size-sm);
}

label.filter-title {
  font-size     : 1rem;
  margin-bottom : var(--size-xs);
}

.filter .input-type {
  flex: none;
}

.input-type label {
  margin: 0;
}

.input-type .radio-group {
  display : flex;
  gap     : .75rem;
}

.input-type >>> .el-radio__label {
  font-size     : var(--size-md);
  padding-left  : .25rem;
}

.filter .input-text {
  flex    : 1;
  display : flex;
  gap     : .75rem;
}

.filter .action {
  flex: none;
}

</style>